module.exports = __webpack_public_path__ + "assets/img/f1d6-gn.svg";